/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react' 
import PropTypes from 'prop-types'
import Aboutus from './views/Aboutus';
  

class AboutusPage extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        return (
            <> 
                <Aboutus /> 
            </>
        )
    }
}

AboutusPage.propTypes = {
    classes: PropTypes.object.isRequired,
}
  
export default AboutusPage;
